import React from "react"
import ContentLoader from "react-content-loader";

const DVpreview = (props) => {
    return(
        <ContentLoader viewBox="0 0 100% 20%" height={"20%"} width={"100%"} backgroundColor="#f3f3f3"
        foregroundColor="#ecebeb" {...props}>
      <rect x="0" y="0" rx="5" ry="5" width="40%" height="20" />
      <rect x="0" y="42" rx="5" ry="5" width="100%" height="100" />
    </ContentLoader>
    )
}
DVpreview.metadata = {
    name: 'DaniloWoz',
    github: 'DaniloWoz',
    description: 'Simple Article',
    filename: 'DVpreview',
  }
export default DVpreview